import { createSelector } from 'reselect'

const select = (state) => state.tutorialList

const selectTutorials = createSelector(
  select,
  (tutorialList) => tutorialList.tutorials
)

const selectTutorialsFetching = createSelector(
  select,
  (tutorialList) => tutorialList.isFetching
)

export { selectTutorials, selectTutorialsFetching }
